// src/components/Esim/EsimActionsSection/EsimActionsSection.jsx
import React, { useState, useEffect, useRef, Suspense } from "react";
import InstallationGuide from "../InstallationGuide/InstallationGuide";
import TopUpPackagesSection from "../../Esim/TopUpPackagesSection/TopUpPackagesSection";
import EsimActions from "../EsimActions/EsimActions";
import "./EsimActionsSection.css";

const EsimActionsSection = ({ selectedEsim }) => {
  const [deviceType, setDeviceType] = useState("IOS");
  const [showTopUp, setShowTopUp] = useState(false);

  const topUpRef = useRef(null);

  useEffect(() => setShowTopUp(false), [selectedEsim]);

  useEffect(() => {
    if (showTopUp && topUpRef.current) {
      setTimeout(() => {
        topUpRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  }, [showTopUp]);

  return (
    <div className="esim-actions-wrapper">
      <div className="esim-actions-section">
        <InstallationGuide selectedEsim={selectedEsim} deviceType={deviceType} setDeviceType={setDeviceType} />
        <EsimActions
          selectedEsim={selectedEsim}
          deviceType={deviceType}
          onToggleTopUp={() => setShowTopUp((prev) => !prev)}
          isTopUpOpen={showTopUp}
        />
      </div>
      {showTopUp && selectedEsim && (
        <Suspense fallback={<div className="loading-text">Loading top-up section...</div>}>
          <div ref={topUpRef} style={{ width: "100%" }}>
            <TopUpPackagesSection iccid={selectedEsim.iccid} esimDetails={selectedEsim} />
          </div>
        </Suspense>
      )}
    </div>
  );
};

export default EsimActionsSection;
